if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
        if (!this.mainButton) return;

        this.button = this.querySelector('.sticky-atc__button');
        this.text = this.querySelector('.sticky-atc__text');

        this.button.addEventListener('click', () => this.mainButton.click());

        // Mirror disabled / sold out / loading state of the main button (set by product-form.js and product-info.js).
        this.mutationObserver = new MutationObserver(() => this.syncState());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });

        // Only show once the main button has been scrolled past (above the viewport), not while it's still below the fold.
        this.intersectionObserver = new IntersectionObserver(([entry]) =>
          this.toggle(!entry.isIntersecting && entry.boundingClientRect.bottom < 0)
        );
        this.intersectionObserver.observe(this.mainButton);

        this.syncState();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        document.body.classList.remove('sticky-atc-visible');
      }

      toggle(visible) {
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('sticky-atc-visible', visible);
      }

      syncState() {
        const mainText = this.mainButton.querySelector('span');
        if (mainText) this.text.textContent = mainText.textContent.trim();
        this.button.toggleAttribute('disabled', this.mainButton.hasAttribute('disabled'));
        this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));
      }
    }
  );
}
